import Axios from 'axios';
import Moment from 'moment';
import router from '@/router';

// eslint-disable-next-line no-unused-vars
function isValidDate(d) {
  // eslint-disable-next-line no-restricted-globals
  return d instanceof Date && !isNaN(d);
}

function getHall(zone = '') {
  const hall = (zone.split('[')[1] || '').split(']')[0];
  return (hall && hall.length > 0 && hall.length !== zone.length) ? hall : false;
}

/* eslint-disable no-param-reassign */
export default async ({
  commit, getters, state, dispatch,
}) => {
  const query = [];
  // let dayForceUpdate = false;
  if (state.count === 0) {
    state.count += 1;
    let forceDay = true;

    Object.keys(state.filters)
      .forEach((key) => {
        if (typeof router.currentRoute.query[key] !== 'undefined') {
          forceDay = false;
        }
      });

    Object.keys(state.filters)
      .forEach((key) => {
        let value = router.currentRoute.query[key];
        value = value ? value.trim() : '';
        if (key === 'days' && value && value.length > 0) {
          // value = [Moment(value).format('DD/MM').toString(), value];
        }
        if (key === 'days' && forceDay) {
          value = 'update';
        }
        if (key === 'lang') {
          // if (['en', 'ru'].indexOf(value) === -1) value = 'ru';
          value = '';
        }
        if (value.length > 0) query.push({ key, value });
      });
  }
  if (query.length > 0) {
    dispatch('setFilter', query);
  } else {
    const headers = {};

    let hash = null;

    if (state.showPivot) {
      try {
        const res = await Axios.get('/app/hash');
        const { data } = res;
        if (data.t && data.h) {
          hash = [data.t, data.h].join(';');
        }
        headers['X-APP-PIVOT'] = hash;
      } catch (error) {
        state.showPivot = false;
      }
    }
    state.progressActive = true;
    Axios
      .get('/api/events/v2/tobolsk/2024-summer', {
        params: getters.filtersQuery,
        headers,
      })
      .then((result) => {
        setTimeout(() => {
          state.progressActive = false;
        }, 500);
        const data = typeof result.data === 'object' ? result.data : {};
        state.startDay = data.startDay ? data.startDay : false;
        const filters = typeof data.filters === 'object' ? data.filters : {};
        data.filters = filters;
        const events = Array.isArray(data.events) ? data.events : [];
        data.events = events;

        state.stylesConfig = data.styles || {};

        filters.days = filters.days && Array.isArray(data.filters.days) ? filters.days : [];
        filters.days = filters.days.map((d, index) => {
          let text = false;
          let type = 'date';
          if (d === 'soon' || d === 'now') {
            type = 'text';
            if (d === 'soon') text = 'Скоро';
            if (d === 'now') text = 'Сейчас';
          } else {
            text = d && Moment(d).isValid() ? Moment(d).format('DD/MM').toString() : false;
          }
          return {
            text, value: d, type, index,
          };
        }).filter((e) => e.value !== false);

        Object.keys(filters).forEach((key) => {
          filters[key] = filters[key].map((v, index) => {
            if (typeof v === 'object') {
              v.index = index;
            } else {
              v = {
                text: v,
                value: v,
                type: 'text',
                index,
              };
            }
            return v;
          });
        });

        let nocid = 0;
        data.events = events
          .map((event) => {
            let covers = (event.linked_objects || [])
              .filter((e) => e.is_cover)
              .map((e) => e.image);
            if (covers.length === 0) {
              covers = false;
              nocid += 1;
            }

            event.title = event.title.replace(/(?:\r\n|\r|\n)/g, '<br/>');
            event.hasCover = !!covers[0] && process.env.VUE_APP_SHOW_COVER === 'yes';
            // eslint-disable-next-line prefer-destructuring
            event.cover = covers[0];
            // `${process.env.BASE_URL}/ph/v2/${((nocid % 8) + 1).toString().padStart(2, '0')}.jpg`

            // event.title = event.title.replace(/(?:\r\n|\r|\n)/g, '<br/><br/>');
            return {
              ...event,
              visible: true,
              render: false,
              cast: '',
              hall: getHall(event.zone),
              covers,
              nocid,
            };
          });

        commit('setAgenda', data);

        state.reload = false;

        state.templates = data.templates || [];

        const initialFilter = Object.keys(state.filters)
          .filter((key) => key !== 'lang' && state.filters[key] !== false); // && key !== 'search');
        if (data.events.length === 0 && initialFilter.indexOf('days') !== -1) {
          const check = data.filters.days.filter((e) => e.value === state.filters.days);
          if (check.length === 0) {
            if (state.filters.days === 'update') {
              dispatch('setFilter', [{ key: 'days', value: data.startDay[1] }]);
            } else {
              dispatch('setFilter', [{ key: 'days', value: data.filters.days[data.filters.days.length - 1] }]);
            }
            return;
          }
        }
        if (initialFilter.length === 0 && filters.days.length > 0) {
          /**
          state.reload = true;
          let delta = Infinity;
          let cDay = filters.days[0];
          filters.days.forEach((d) => {
            const testDay = typeof d === 'string' ? d : d.value;
            if (testDay && isValidDate(testDay)) {
              const testDelta = Math.abs(window.moment(testDay).unix() -
                                window.moment(window.moment().format('YYYY-MM-DD')).unix());
              if (testDelta < delta) {
                delta = testDelta;
                cDay = d;
              }
            }
          });
          if (cDay.type !== 'text' && window.moment(cDay.value).unix() <
                                      window.moment(state.startDay[1]).unix()) {
            cDay = { text: state.startDay[0], value: state.startDay[1] };
          } else {
            cDay = { text: state.startDay[0], value: state.startDay[1] };
          }
          dispatch('setFilter', [{ key: 'days', value: cDay }]); * */
        } else {
          state.reload = false;
        }
      })
      .catch(() => {
        setTimeout(() => {
          state.progressActive = false;
        }, 500);
      });
  }
};
